import sharedActions from '@/campaign-form-shared/store/actions'
import ajax from '@/helpers/ajax'
import { objectKeysToSnakeCase } from '@/helpers/transform-object-keys'
import { trackEvent } from '@/analytics/track'

function createPetitionStart({ state, commit, dispatch }) {
  commit('setSubmitInProgress', true)

  return new Promise((resolve) => {
    ajax.post({
      url: state.createUrl,
      data: {
        petition: objectKeysToSnakeCase({
          ...state.values,
          locale: state.extraParameters.locale,
          source: state.extraParameters.source,
          source_partnership: state.extraParameters.source_partnership,
          external_action_id: state.extraParameters.external_action_id
        })
      },
      successHandler: (response) => {
        if (response.success) {
          commit('setPetitionStartToken', response.petition.token)
          commit('setUpdateUrl', response.updateUrl)
          commit('setPublishUrl', response.publishUrl)
          commit('setRequestHelpUrl', response.requestHelpUrl)
          commit('setPetitionStartCreated', true)
          commit('setCurrentField', response.petition.currentStep)
          commit('setPetitionStartUrl', response.petitionStartUrl)

          dispatch('trackFieldShown')

          // Clear validation errors
          commit('setValidationErrors', {})
        } else {
          commit('setValidationErrors', response.validationErrors)
        }

        commit('setSubmitInProgress', false)
        resolve(response.success)
      }
    })
  })
}

function updatePetitionStart({ state, commit, getters, dispatch }) {
  commit('setSubmitInProgress', true)

  return new Promise((resolve) => {
    ajax.put({
      url: state.updateUrl,
      data: {
        petition: objectKeysToSnakeCase(state.values)
      },
      successHandler: (response) => {
        if (response.success) {
          if (response.finished) {
            // Last step is either authenticating the user to associate with the new petition
            // or redirecting to the petition page (if the user was already signed in)
            if (response.requiresAuthentication) {
              if (response.forceSingleSignOn) {
                window.location = response.singleSignOnRedirect.url
              } else {
                commit('setAuthenticationModalData', response.authenticationModalData)
                commit('setDisplayAuthenticationModal', true)
                commit('setLinkUserUrl', response.linkUserUrl)

                trackEvent(
                  'Login/Signup Modal Shown',
                  {
                    action: 'auth-modal-shown',
                    category: 'petition-start-form'
                  }
                )
              }
            } else if (response.requiresApproval) {
              commit('setDisplayAwaitingApprovalModal', true)
            } else if (response.redirectUrl) {
              window.location = response.redirectUrl
            }
          } else {
            commit('setCurrentField', response.petition.currentStep)
            dispatch('trackFieldShown')
          }

          // Clear validation errors
          commit('setValidationErrors', {})
          commit('clearRequestHelpPrompt')
        } else {
          commit('setValidationErrors', response.validationErrors)

          if (response.helpPromptEnabled && !state.helpRequested) {
            commit('setRequestHelpPromptOnField', getters.firstFieldWithError)
          } else {
            commit('clearRequestHelpPrompt')
          }
        }

        commit('setSubmitInProgress', false)
        resolve(response.success)
      }
    })
  })
}

export default {
  ...sharedActions,

  publish({ state, commit }) {
    commit('setSubmitInProgress', true)

    ajax.post({
      url: state.publishUrl,
      successHandler: (response) => {
        commit('setSubmitInProgress', false)
        if (response.success) {
          if (response.requiresApproval) {
            commit('setDisplayAwaitingApprovalModal', true)
          } else {
            window.location = response.redirectUrl
          }
        }
      }
    })
  },

  submitField({ state, commit, getters, dispatch }) {
    if (!state.petitionStartCreated) {
      return createPetitionStart({ state, commit, dispatch })
    } else {
      return updatePetitionStart({ state, commit, getters, dispatch })
    }
  },

  trackFieldShown({ getters }) {
    trackEvent(
      getters.trackingEventNameForCurrentField,
      getters.trackingEventDataForCurrentField
    )
  }
}
